import styled from 'styled-components'

import { ReactComponent as Globe } from '@sketch/icons/globe-17'
import { Text } from '@sketch/components'

export const Wrapper = styled.div`
  display: flex;
  margin: 0px 16px;
  align-items: center;
`
export const GlobeIcon = styled(Globe)`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  flex-shrink: 0;
`

export const StyledText = styled(Text)`
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  margin-left: 8px;
  font-size: ${({ theme }) => theme.fontSizes.D};
  /* To correctly vertically center the icon with the text */
  line-height: 1.4; /* stylelint-disable-line scales/line-heights */
`

export const Bold = styled.strong`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`
